// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS ServiceTypes INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import ServiceType from "./components/ServiceType";
/**
 * @visibleName ServiceTypes DEPRECATED
*/

var ServiceTypes = function ServiceTypes(_ref) {
  var iconColor = _ref.iconColor,
    _ref$serviceTypes = _ref.serviceTypes,
    serviceTypes = _ref$serviceTypes === void 0 ? [] : _ref$serviceTypes;
  return /*#__PURE__*/React.createElement("ul", {
    className: "ui-service-types list-unstyled"
  }, serviceTypes.map(function (st) {
    return /*#__PURE__*/React.createElement(ServiceType, {
      iconColor: iconColor,
      key: "service-type-".concat(st.code),
      level: 0,
      serviceType: st,
      showIcon: true
    });
  }));
};
ServiceTypes.propTypes = {
  /** color of ServiceType icons */
  iconColor: PropTypes.string,
  /** array of serviceType objects */
  serviceTypes: PropTypes.array.isRequired
};
ServiceTypes.defaultProps = {
  iconColor: '#712F79' // $eggplant-color
};
export default ServiceTypes;